import FuseUtils from '@fuse/utils';
import AppContext from 'app/AppContext';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { matchRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';

class FuseAuthorization extends Component {
  constructor(props, context) {
    super(props);
    const { routes } = context;
    this.state = {
      accessGranted: true,
      routes
    };
  }

  componentDidMount() {
    if (!this.state.accessGranted) {
      this.redirectRoute();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.accessGranted !== this.state.accessGranted;
  }

  componentDidUpdate() {
    if (!this.state.accessGranted) {
      this.redirectRoute();
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { location, userRole } = props;
    const { pathname } = location;

    const matched = matchRoutes(state.routes, pathname)[0];
    // Kept so `redirectRoute` can tell *why* it was refused, which decides where
    // the person goes next.
    const routeAuth = matched ? matched.route.auth : null;

    return {
      accessGranted: matched ? FuseUtils.hasPermission(routeAuth, userRole) : true,
      routeAuth
    };
  }

  redirectRoute() {
    const { location, userRole, history } = this.props;
    const { routeAuth } = this.state;
    const { pathname, state } = location;
    const redirectUrl = state && state.redirectUrl ? state.redirectUrl : '/';

    /*
        User is guest
        Redirect to Login Page
        */
    if (!userRole || userRole.length === 0) {
      history.push({
        pathname: '/login',
        state: { redirectUrl: pathname }
      });
    } else if (Array.isArray(routeAuth) && routeAuth.length === 0) {
      /*
        A guests-only page — `authRoles.onlyGuest`, so the login and password
        screens — reached by somebody who is signed in. Nothing was refused: this is
        what happens the instant a sign-in succeeds, since the account now holds
        permissions and the login screen asks for none.

        It is also the *only* thing that redirects after signing in; no login handler
        pushes a route. Sending it to the 403 page, as a refusal, meant every sign-in
        landed on "You don't have access to this page".
      */
      history.push({
        pathname: redirectUrl
      });
    } else {
      /*
        User is a member who may not open this page.

        Two different situations arrive here, and they are told apart by whether the
        navigation carried a `redirectUrl`:

          - It did. They were bounced somewhere on their way to a page they *can*
            open — signing in is the case that does this — so send them on to it.

          - It did not. They asked for a page that is not theirs. This used to push
            them silently at the home page, which is indistinguishable from a broken
            link and was reported as one. Say so instead.
        */
      const wasSentHere = Boolean(state && state.redirectUrl);

      history.push({
        pathname: wasSentHere ? redirectUrl : '/pages/errors/error-403'
      });
    }
  }

  render() {
    // console.info('Fuse Authorization rendered', accessGranted);
    return this.state.accessGranted ? <>{this.props.children}</> : null;
  }
}

function mapStateToProps({ auth }) {
  return {
    userRole: auth.user.role
  };
}

FuseAuthorization.contextType = AppContext;

export default withRouter(connect(mapStateToProps)(FuseAuthorization));
